import { actions } from "xstate"
import { SubmitStatusActor, SubmitStatusEvents } from "../../submit-status-machine"
import { ECommerceEvent } from "../e-commerce-machine"
import { ECommerceContext } from "../e-commerce-machine-context"

type Context = ECommerceContext
type Events = ECommerceEvent

export const submitStatusActions = {
    submitStatusStart: actions.sendTo<Context, Events, SubmitStatusActor>(
        (ctx) => ctx.services.submitStatus,
        (_, __) => ({ type: "START" }),
    ),
    submitStatusReset: actions.sendTo<Context, Events, SubmitStatusActor>(
        (ctx) => ctx.services.submitStatus,
        (_, __) => ({ type: "RESET" }),
    ),
    submitStatusComplete: actions.sendTo<Context, Events, SubmitStatusActor>(
        (ctx) => ctx.services.submitStatus,
        (_, __) => ({ type: "COMPLETE" }),
    ),
}
